import FileList from './FileList';
import CodeViewer from './CodeViewer';
import ChatPanel from './ChatPanel';
import type { ReplayBundleV1 } from '@arrowise/shared';

interface ReplayContentProps {
    bundle: ReplayBundleV1;
    visibleFiles: Array<{ identity: string; displayName: string; createdAtMs: number; deletedAtMs?: number }>;
    selectedIdentity: string | undefined;
    onSelectFile: (identity: string) => void;
    currentFileContent: string;
    effectiveT: number;
    t: number;
    onSeekToTime: (t: number) => void;
}

export default function ReplayContent({
    bundle,
    visibleFiles,
    selectedIdentity,
    onSelectFile,
    currentFileContent,
    effectiveT,
    t,
    onSeekToTime
}: ReplayContentProps) {
    return (
        <div className="grid grid-cols-12 gap-4">
            <FileList
                visibleFiles={visibleFiles}
                selectedIdentity={selectedIdentity}
                onSelectFile={onSelectFile}
            />
            <CodeViewer
                bundle={bundle}
                selectedIdentity={selectedIdentity}
                currentFileContent={currentFileContent}
                t={t}
            />
            <ChatPanel
                bundle={bundle}
                effectiveT={effectiveT}
                onSeekToTime={onSeekToTime}
            />
        </div>
    );
}
